import { createFileRoute, redirect } from "@tanstack/react-router";
import { isSignedOutError } from "@/lib/queryClient";
import { meQueryOptions } from "@/hooks/useCloudChat";
import { SetupSignOut } from "@/components/SetupSignOut";

// Self-serve workspace creation is closed — onboarding is invite-only. A user
// who reaches this screen is authenticated but belongs to no workspace and has
// no pending invite (an invited user is auto-added by the redeem trigger and is
// redirected to "/" by the guard below). Workspaces are created by LATO staff in
// the Admin area, or members are invited by a workspace's own owners/admins.
function SetupInviteWall() {
  return (
    <div className="relative flex h-full w-full flex-col p-6">
      <SetupSignOut />
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="w-full max-w-sm space-y-4 text-center">
          <h1 className="text-headline font-normal">You're not in a workspace yet</h1>
          <p className="text-body text-muted-foreground">
            LATO is invite-only. Ask your workspace owner or admin to invite you,
            or reach out to{" "}
            <a
              href="mailto:hi@latolabs.io"
              className="text-foreground underline underline-offset-2 hover:opacity-80"
            >
              hi@latolabs.io
            </a>{" "}
            to get set up.
          </p>
        </div>
      </div>

      <div className="flex justify-center pb-4">
        <img
          src="/assets/lato-grid-black.svg"
          alt="Lato"
          className="h-8 object-contain dark:hidden"
        />
        <img
          src="/assets/lato-grid-white.svg"
          alt="Lato"
          className="h-8 object-contain hidden dark:block"
        />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_auth/setup/workspace")({
  beforeLoad: async ({ context }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQueryOptions);
      if (me.organization != null) {
        throw redirect({ to: "/" });
      }
    } catch (e) {
      if (isSignedOutError(e)) {
        throw redirect({ to: "/signin", search: { redirect: "" } });
      }
      throw e;
    }
  },
  component: SetupInviteWall,
});
